import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

import context from "../store/context";

import MainLogo from "../assets/logowhite.svg";
import DateConverter from "../components/DateConverter";

import UserIcon from "../components/icons/User";
import TagIcon from "../components/icons/Tag";
import BellIcon from "../components/icons/Bell";
import MessageIcon from "../components/icons/Message";
import BookIcon from "../components/icons/Book";
import CheckShieldIcon from "../components/icons/CheckShield";
import InfoIcon from "../components/icons/Info";
import ArrowIcon from "../components/icons/Arrow";

const iconStyle = "w-6 h-6 fill-[#3d5984]/20";

const SettingRow = ({ icon, label, to, last, onClick }) => {
  const content = (
    <>
      <span className="text-[#3d5984] shrink-0">{icon}</span>
      <span
        className={`flex-1 flex items-center py-4 pr-5 ${
          last ? "" : "border-b border-gray-100"
        }`}
      >
        <span className="flex-1 text-[#1f2937]">{label}</span>
        <ArrowIcon styles="w-4 h-4 text-gray-400" />
      </span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-4 pl-5 w-full text-left active:bg-gray-50 transition-colors"
      >
        {content}
      </button>
    );
  }

  return (
    <Link
      to={to}
      className="flex items-center gap-4 pl-5 active:bg-gray-50 transition-colors"
    >
      {content}
    </Link>
  );
};

const TelegramAccount = () => {
  const { userInfo, HandleSubscription, isFetchingInvoice } =
    useContext(context);

  const isActive = Number(userInfo?.is_active) === 1;

  useEffect(() => {
    window.Telegram?.WebApp?.BackButton?.hide();
  }, []);

  return (
    <div className="w-full h-screen overflow-y-auto bg-[#664bc7] flex flex-col">
      <div className="shrink-0 text-white px-5 pt-6 pb-8">
        <img src={MainLogo} alt="iChereta" className="h-8" />

        <div className="mt-6 flex items-center gap-3 flex-wrap">
          <h1 className="text-xl font-bold leading-tight">
            {userInfo?.name || "iChereta member"}
          </h1>
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold bg-white ${
              isActive ? "text-green-600" : "text-red-500"
            }`}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        </div>
        <p className="mt-1 text-lg font-semibold tracking-wide">
          {userInfo?.phone || ""}
        </p>

        <div className="mt-4 h-[3px] w-full bg-white/25 rounded-full" />

        <div className="mt-4 grid grid-cols-3 gap-2">
          <div>
            <p className="text-white/70 text-xs">Subscription Plan:</p>
            <p className="font-semibold text-sm mt-0.5">
              {userInfo?.latest_plan || "—"}
            </p>
          </div>
          <div>
            <p className="text-white/70 text-xs">Start Date:</p>
            <div className="font-semibold text-sm mt-0.5">
              {userInfo?.latest_plan_start_date ? (
                <DateConverter dateString={userInfo.latest_plan_start_date} />
              ) : (
                "—"
              )}
            </div>
          </div>
          <div>
            <p className="text-white/70 text-xs">End Date:</p>
            <div className="font-semibold text-sm mt-0.5">
              {userInfo?.latest_plan_end_date ? (
                <DateConverter dateString={userInfo.latest_plan_end_date} />
              ) : (
                "—"
              )}
            </div>
          </div>
        </div>

        {!isActive && (
          <button
            type="button"
            onClick={() => HandleSubscription()}
            disabled={isFetchingInvoice}
            className="mt-5 w-full py-2.5 rounded-full bg-white text-[#664bc7] font-semibold text-sm active:scale-[0.99] transition-transform"
          >
            {isFetchingInvoice ? "Starting payment…" : "Pay subscription"}
          </button>
        )}
      </div>

      <div className="flex-1 bg-gray-100 rounded-t-[28px] px-4 pt-6 pb-28">
        <div className="max-w-[600px] mx-auto space-y-6">
          <section>
            <h2 className="px-1 mb-2 text-xs font-semibold tracking-wider uppercase text-gray-400">
              Settings
            </h2>
            <div className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.05)]">
              <SettingRow
                icon={<UserIcon styles={iconStyle} />}
                label="Account Information"
                to="/account/telegram/info"
              />
              <SettingRow
                icon={<TagIcon styles={iconStyle} />}
                label="Tender Preference"
                to="/account/telegram/preferences"
              />
              <SettingRow
                icon={<BellIcon styles={iconStyle} />}
                label="Alert Settings"
                to="/account/telegram/alerts"
                last
              />
            </div>
          </section>

          <section>
            <h2 className="px-1 mb-2 text-xs font-semibold tracking-wider uppercase text-gray-400">
              Information
            </h2>
            <div className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.05)]">
              <SettingRow
                icon={<MessageIcon styles={iconStyle} />}
                label="FAQ"
                to="/FAQ/telegram"
              />
              <SettingRow
                icon={<BookIcon styles={iconStyle} />}
                label="TOS"
                to="/TOS/telegram"
              />
              <SettingRow
                icon={<CheckShieldIcon styles={iconStyle} />}
                label="Privacy Policy"
                to="/privacy/telegram"
              />
              <SettingRow
                icon={<InfoIcon styles={iconStyle} />}
                label="About"
                to="/about/telegram"
                last
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TelegramAccount;
